import util from '../lib/util';
import { selectProjectModel } from './ProjectSpecifics';
import { selectIdTypeModel } from './CustomerDetails';
import { selectedAddress } from './ServiceAddress';


const selectCustomerDetail = () => (state) => {
    if (state.form)
        return {
            FirstName: state.form.accountHolderInfo_residentInfo_firstName,
            LastName: state.form.accountHolderInfo_residentInfo_lastName,
            BusinessName: state.form.accountHolderInfo_businessInfo_businessName,
            Email: state.form.emailAddress,
            PrimaryPhone: state.form.accountHolderInfo_phoneContact_primaryPhone,
            PrimaryPhoneExt: state.form.accountHolderInfo_phoneContact_primaryPhone_ext,
            SecondaryPhone: state.form.accountHolderInfo_phoneContact_secondaryPhone,
            SecondaryPhoneExt: state.form.accountHolderInfo_phoneContact_secondaryPhone_ext,
            PrimaryCellPhone: state.form.accountHolderInfo_phoneContact_primaryCellPhone,
            PrimaryCellPhoneExt: state.form.accountHolderInfo_phoneContact_primaryCellPhone_ext,
            SecondaryCellPhone: state.form.accountHolderInfo_phoneContact_secondaryCellPhone,
            SecondaryCellPhoneExt: state.form.accountHolderInfo_phoneContact_secondaryCellPhone_ext,
        };
    return null;
};
const selectworkSiteContactModel = () => (state) => {
    if (state.form)
        return {
            Name: state.form.workSiteContactName,
            PrimaryPhone: state.form.workSiteContactPhone,
            PrimaryPhoneExt: state.form.workSiteContactPhone_ext,
            PrimaryCellPhone: state.form.workSiteCellPhone,
            Position: state.form.workSiteContactPosition
        };
    return null;
};
const nullAddress = {
    id: 0, unitNumber: null, streetNumber: null, streetName: null, postCode: null, poBox: null,
    addressSubType: { id: 0, name: null, sortOrder: 0 },
    addressType: { id: 0, name: null, sortOrder: 0 },
    city: { id: 0, name: null, sortOrder: 0 },
    coordinate: { id: 0, lat: 0, lng: 0 },
    country: { id: 0, name: null, sortOrder: 0 },
    province: { id: 0, name: null, sortOrder: 0 },
    streetDirection: { id: 0, name: null, sortOrder: 0 },
    streetType: { id: 0, name: null, sortOrder: 0 },
};

const selectSubmitModel = (state) => {

    const f = state.form;
    const g = state.gas;
    const projectModelNewGasLine = selectProjectModel(state);
    projectModelNewGasLine.id = state.gas.project && state.gas.project.data.projectNo;

    let dob = new String(f.accountHolderInfo_residentInfo_dob);
    if (f.accountHolderInfo_residentInfo_dob)
        dob = util.DobFormatter(dob);
    else
        dob = null;

    const billingMethodName = util.getNamebyId(window.osa.lookup.customerDetails.billingMethod.items, f.billingMethod);
    const customerTypeName = util.getNamebyId(window.osa.lookup.customerDetails.customerTypes.items, f.customerType);
    const identificationTypeName = f.customerType=="1" ? util.getNamebyId(window.osa.lookup.customerDetails.idType.items, f.idType) : "Business Number";
    const identificationValue = selectIdTypeModel(state).Value;
    const emergencyContact = {
        id: 0,
        address: nullAddress,
        businessPhone: f.emergencyContactPrimaryPhone || "",
        businessPhoneExt: f.emergencyContactPrimaryPhone_ext || "",
        company: null,
        contactType: { id: 0, name: "Emergency Contact", sortOrder: 1 },
        dob: null,
        firstName: f.emergencyContactFirstName || "",
        lastName: f.emergencyContactLastName || "",
        mobilePhone: null,
    };
    const addressSubType = util.getNamebyId(window.osa.lookup.customerDetails.billingAddress.items, f.billingAddress);
    const address = selectedAddress(state);
    const mailingAddress = {
        addressSubType: { id: 1, name: addressSubType, sortOrder: 1 },
        addressType: { id: 2, name: "Mailing Address", sortOrder: 2 },
        city: { id: 0, name: address.city, sortOrder: 0 },
        coordinate: { id: 0, lat: 0, lng: 0 },
        country: { id: 0, name: address.country },
        id: 0,
        poBox: null,
        postCode: address.postCode,
        province: { id: 0, name: address.province },
        streetDirection: { name: address.streetDirection || "" },
        streetName: address.streetName || "",
        streetNumber: address.streetNumber || "",
        streetType: { id: 0, name: address.streetType || "", sortOrder: 0 },
        unitNumber: address.unitNumber || "",
    };
    const secondaryAccountContact = {
        address: mailingAddress,
        businessPhone: f.secondAccountContactPrimaryPhone || "",
        businessPhoneExt: f.secondAccountContactPrimaryPhone_ext || "",
        company: null,
        contactType: { id: 2, name: "Secondary Account Contact", sortOrder: 2 },
        dob: "-0-0",
        firstName: f.secondAccountContactFirstName || "",
        id: 0,
        lastName: f.secondAccountContactLastName || "",
        mobilePhone: null
    };
    const customer = {
        additionalContacts: [],
        bpNumber: g.user.bpNumber,
        businessAgreements: [
            {
                baNumber: g.baNumber,
                billingMethod: { id: 1, name: billingMethodName, sortOrder: 1 },
                id: 0,
                isTermAndConditionAccepted: true,
                projects: [projectModelNewGasLine.Project]
            }
        ],
        companyName: f.accountHolderInfo_businessInfo_businessName,
        customerSubType: { id: 0, name: null, sortOrder: 0 },
        customerType: { id: 1, name: customerTypeName, sortOrder: 1 },
        dob,
        email: f.emailAddress,
        emergencyContact,
        firstName: f.accountHolderInfo_residentInfo_firstName,
        lastName: f.accountHolderInfo_residentInfo_lastName,
        id: 0,
        identificationType: { id: 1, name: identificationTypeName, sortOrder: 1 },
        identificationValue,
        isContractor: (f.customerType && f.customerType == "3"),
        isEmailNewsAllowed: projectModelNewGasLine.IsEmailNewsAllowed,
        isEmailNotificationAllowed: projectModelNewGasLine.IsEmailNotificationAllowed,
        mailingAddress,
        primaryCellPhone: f.accountHolderInfo_phoneContact_primaryCellPhone || "",
        primaryPhone: f.accountHolderInfo_phoneContact_primaryPhone || "",
        primaryPhoneExt: f.accountHolderInfo_phoneContact_primaryPhone_ext || "",
        secondaryAccountContact,
        secondaryCellPhone: f.accountHolderInfo_phoneContact_secondaryCellPhone || "",
        secondaryPhone: f.accountHolderInfo_phoneContact_secondaryPhone || "",
        secondaryPhoneExt: f.accountHolderInfo_phoneContact_secondaryPhone_ext || "",
    };
    return {
        id: 0,
        currentStepNumber: 0,
        AdditionalNotes: f.additionalNotes,
        HeatingSystem : f.heatingSystem,
        AgeOfProperty : f.ageOfProperty,
        customer,
        statusType: { id: 0, name: null, sortOrder: 0 }
    };
};


export {
    selectCustomerDetail,
    selectworkSiteContactModel,
    selectSubmitModel,
};